var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm._m(0);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', {
    staticClass: "page-section page-section--last"
  }, [_c('div', {
    staticClass: "mb-60 mb-md-30"
  }, [_c('div', {
    staticClass: "mb-10"
  }, [_c('h3', {
    staticClass: "text-28 text-md-20"
  }, [_vm._v("데이터분석기반 전자제조 전문인력양성")])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-lg-6 order-lg-2"
  }, [_c('div', {
    staticClass: "img-wrap text-lg-right"
  }, [_c('img', {
    attrs: {
      "src": "/images/sub/about/business-img3.png",
      "alt": "이미지"
    }
  })])]), _c('div', {
    staticClass: "col-12 col-lg-6 order-lg-1"
  }, [_c('div', {
    staticClass: "text-items"
  }, [_c('div', {
    staticClass: "text-item"
  }, [_c('div', {
    staticClass: "text-item__tit text-18 text-lg-16"
  }, [_c('strong', [_vm._v("사업명")])]), _c('div', {
    staticClass: "text-item__txt"
  }, [_c('p', {
    staticClass: "page-text"
  }, [_vm._v("데어터분석기반 전자제조 전문인력양성")])])]), _c('div', {
    staticClass: "text-item"
  }, [_c('div', {
    staticClass: "text-item__tit text-18 text-lg-16"
  }, [_c('strong', [_vm._v("사업기간")])]), _c('div', {
    staticClass: "text-item__txt"
  }, [_c('p', {
    staticClass: "page-text"
  }, [_vm._v("’21.3.1 ~ ’26.2.28 (5년)")])])]), _c('div', {
    staticClass: "text-item"
  }, [_c('div', {
    staticClass: "text-item__tit text-18 text-lg-16"
  }, [_c('strong', [_vm._v("지원내용")])]), _c('div', {
    staticClass: "text-item__txt"
  }, [_c('p', {
    staticClass: "page-text line-height-18"
  }, [_vm._v("단기집중교육운영, 데이터 활용이 가능한 전자제조전문인력(年30명) 배출")])])]), _c('div', {
    staticClass: "text-item"
  }, [_c('div', {
    staticClass: "text-item__tit text-18 text-lg-16"
  }, [_c('strong', [_vm._v("사업목표")])]), _c('div', {
    staticClass: "text-item__txt"
  }, [_c('p', {
    staticClass: "page-text line-height-18"
  }, [_vm._v("스마트전자 산업의 전자제조생태계 기반으로 현장중심의 데이터기반 전자제조 혁신 인재양성")])])]), _c('div', {
    staticClass: "text-item"
  }, [_c('div', {
    staticClass: "text-item__tit text-18 text-lg-16"
  }, [_c('strong', [_vm._v("컨소시엄")])]), _c('div', {
    staticClass: "text-item__txt"
  }, [_c('p', {
    staticClass: "page-text line-height-18"
  }, [_vm._v("숭실대(전자), 숙명여대(경영분석), 서울과기대(데이터사이언스), KEA(제조/장비)")])])])])])])]), _c('div', [_c('div', {
    staticClass: "mb-30 mb-md-15"
  }, [_c('div', {
    staticClass: "card card--shadow"
  }, [_c('div', {
    staticClass: "row card--shadow__row"
  }, [_c('div', {
    staticClass: "col-12 col-lg-2"
  }, [_c('span', {
    staticClass: "card--shadow__tit text-20 text-lg-18 font-weight-medium"
  }, [_c('strong', {
    staticClass: "color-primary"
  }, [_vm._v("1 ")]), _vm._v("추진목표")])]), _c('div', {
    staticClass: "col-12 col-lg-10"
  }, [_c('p', {
    staticClass: "card--shadow__txt page-text"
  }, [_c('span', {
    staticClass: "color-primary"
  }, [_vm._v("용산 전자지구의 제조장비, 생태계, 고객데이터를 활용한 교육프로그램 운영을 통해 전자+제조+데이터+경영에 대한 이해도가 높은 산업혁신인재 양성")])])])])])]), _c('div', {
    staticClass: "mb-30 mb-md-15"
  }, [_c('div', {
    staticClass: "card card--shadow"
  }, [_c('div', {
    staticClass: "row card--shadow__row"
  }, [_c('div', {
    staticClass: "col-12 col-lg-2"
  }, [_c('span', {
    staticClass: "card--shadow__tit text-20 text-lg-18 font-weight-medium"
  }, [_c('strong', {
    staticClass: "color-primary"
  }, [_vm._v("2 ")]), _vm._v("추진전략")])]), _c('div', {
    staticClass: "col-12 col-lg-10"
  }, [_c('div', {
    staticClass: "card--shadow__txt page-text"
  }, [_c('p', [_vm._v("1. "), _c('span', {
    staticClass: "color-primary"
  }, [_vm._v("용산 전자지구")]), _vm._v(" 기반 현장교육 (전자특화지역)")]), _c('p', [_vm._v("2. "), _c('span', {
    staticClass: "color-primary"
  }, [_vm._v("제조장비")]), _vm._v("를 통한 전주기 교육 (Y-Factory77+용산상상가)")]), _c('p', [_vm._v("3. 대학별 특화 및 유기적 협력을 통한 "), _c('span', {
    staticClass: "color-primary"
  }, [_vm._v("융합교육")])]), _c('p', [_vm._v("4. "), _c('span', {
    staticClass: "color-primary"
  }, [_vm._v("산학 프로젝트 및 제품 데이터")]), _vm._v(" 분석을 통한 전문가 양성")])])])])])]), _c('div', [_c('div', {
    staticClass: "card card--shadow"
  }, [_c('div', {
    staticClass: "row card--shadow__row"
  }, [_c('div', {
    staticClass: "col-12 col-lg-2"
  }, [_c('span', {
    staticClass: "card--shadow__tit text-20 text-lg-18 font-weight-medium"
  }, [_c('strong', {
    staticClass: "color-primary"
  }, [_vm._v("3 ")]), _vm._v("추진방안")])]), _c('div', {
    staticClass: "col-12 col-lg-10"
  }, [_c('div', {
    staticClass: "card--shadow__txt"
  }, [_c('p', {
    staticClass: "page-text"
  }, [_vm._v("특화 집중교육 / 장비기반교육 / 지역산업교육 / 교육과정지역 신설 / 대학별 협력 / 취업 활성화")]), _c('div', {
    staticClass: "img-wrap text-left mt-40 mt-md-10"
  }, [_c('img', {
    attrs: {
      "src": "/images/sub/about/business-img4.png",
      "alt": "이미지"
    }
  })])])])])])])])]);
}]

export { render, staticRenderFns }